import axios from '@/axios.js'
export default {
  fetchReportSettings () {
    const company = JSON.parse(localStorage.getItem('activeCompany') || '{}')
    return axios.get(`/report-setting/${company.id}/all`)
  },
  addReportSettings (context, payload) {
    return axios.post(`/report-setting/${payload.company_id}`, {
      name: payload.name,
      account_id: payload.account_id
    })
  },
  showReportSetting (context, payload) {
    return axios.get(`/report-setting/${payload.company_id}/${payload.report_id}`)
  },
  updateReportSettings (context, payload) {
    return axios.put(`/report-setting/${payload.company_id}/${payload.report_id}`, {
      name: payload.name,
      account_id: payload.account_id,
      section_assignments: payload.section_assignments
    })
  },
  deleteReportSettings (context, payload) {
    return axios.delete(`/report-setting/${payload.company_id}/${payload.report_id}`)
  }
}
